import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';
import { type JSX, cloneElement } from 'react';

const ConfirmDialog = ({
  isLoading = false,
  maxWidth = 'sm',
  message,
  onClose,
  onPrimaryButtonClicked,
  onSecondaryButtonClicked,
  open,
  primaryButtonDisabled = false,
  primaryButtonLabel,
  primaryButtonColor = 'secondary',
  renderElement,
  secondaryButtonDisabled = false,
  secondaryButtonLabel,
}: {
  isLoading?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  message: string | JSX.Element;
  onClose: () => void;
  onPrimaryButtonClicked: () => void;
  onSecondaryButtonClicked?: () => void;
  open: boolean;
  primaryButtonLabel: string;
  primaryButtonDisabled?: boolean;
  primaryButtonColor?:
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  renderElement?: JSX.Element;
  secondaryButtonDisabled?: boolean;
  secondaryButtonLabel?: string;
}) => {
  return (
    <Dialog
      maxWidth={maxWidth}
      open={open}
      onClose={() => {
        !isLoading ? onClose() : null;
      }}
    >
      <DialogContent>
        <Stack
          direction="column"
          sx={{ justifyContent: 'center', alignItems: 'center' }}
        >
          {renderElement &&
            cloneElement(renderElement, {
              ...renderElement.props,
              style: {
                height: '80px',
                width: '50px',
                marginTop: '-15px',
                marginBottom: '-5px',
                ...renderElement.props.style,
              },
            })}
          {typeof message === 'string' ? (
            <Typography>{message}</Typography>
          ) : (
            message
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {secondaryButtonLabel && (
          <Button
            type="submit"
            disabled={secondaryButtonDisabled || isLoading}
            onClick={() =>
              onSecondaryButtonClicked && onSecondaryButtonClicked()
            }
            color="info"
            variant="outlined"
          >
            {secondaryButtonLabel}
          </Button>
        )}
        <Button
          color={primaryButtonColor}
          disabled={primaryButtonDisabled || isLoading}
          loading={isLoading}
          loadingPosition="end"
          onClick={onPrimaryButtonClicked}
          variant="contained"
        >
          {primaryButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
